import { Box } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { AuthService } from '../../../services/auth.service';
import RoleLensBoard from './RoleLensBoard';
import { PEOPLE_TILES_PATH } from '../../../context/DashboardStyleContext';

/**
 * The Thread style of the HR manager home: who is in today, approvals waiting, and one thread per department for today's attendance.
 * The server leaves out any section the caller has no key for, so this stays a thin wrapper. On a 403 it falls back to the Tiles page.
 */
export default function PeopleLensBoard() {
    const institutionId = AuthService.getSelectedInstitution();
    return (
        <Box sx={{ minWidth: 0 }} data-help-page="dashboard.thread.people">
            <RoleLensBoard institutionId={institutionId} lens="people" fallback={<Navigate to={PEOPLE_TILES_PATH} replace />} />
        </Box>
    );
}
